<template>
  <div>
    <div style="display: flex; align-items: center">
      <Header :title="$t('dashboard.welcome')"> </Header>
      <!-- Filter Bar -->
      <div style="display: flex; justify-content: end; width: 100%; gap: 8px; align-items: center">
        <CustomDropdown v-if="roleId === 2" :label="$t('categories.select_tenant')" :placeholder="$t('categories.select_tenant')" v-model="selectedTenantId" :options="tenants" />
        <button v-for="(option, idx) in filterOptions" :key="option" :class="['dayFilterButton', { selected: selectedFilter === option }]" @click="selectFilter(option)">
          {{ filterLabels[idx] }}
        </button>
        <button class="filter-button" @click="showFilterModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M7 14H21M3.5 7H24.5M10.5 21H17.5" stroke="var(--primary-color)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <div v-if="dateRange && dateRange.length === 2" class="date-filter-chip">
          <span class="date-filter-text"> {{ formatDateForDisplay(dateRange[0]) }} - {{ formatDateForDisplay(dateRange[1]) }} </span>
          <button class="date-filter-clear" @click="clearDateFilter">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="#5C656C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div></div>
      </div>
    </div>
    <!-- Summary Section Wrapper -->
    <div class="summary-wrapper">
      <!-- First Row: 3 columns -->
      <div class="row mb-4" v-if="roleId === 1 || roleId === 2 || roleId === 3">
        <div v-if="readPermission" class="col-lg-5">
          <div class="dashboardCard" style="display: flex; align-items: center">
            <!-- <p class="mainNumber">
              <span class="mainTitleDashboard">{{ $t('dashboard.documents.title') }}</span>
            </p> -->
            <!-- <div class="dashboardVR"></div> -->

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.total_files_uploaded }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.documents.uploaded') }}</span>
              </p>
            </div>
            <div class="dashboardVR"></div>

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.total_documents_processed }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.documents.processed') }}</span>
              </p>
            </div>
            <div class="dashboardVR"></div>

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.total_pages_processed }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.documents.pages_processed') }}</span>
              </p>
            </div>
            <p class="mainNumber">
              <img src="/jobs.png" class="dashboardIcons" alt="" />
            </p>
          </div>
        </div>

        <div v-if="readPermission" class="col-lg-5">
          <div class="dashboardCard">
            <p class="mainNumber">
              <span class="mainTitleDashboard">{{ $t('dashboard.jobs.title') }}</span>
            </p>
            <div class="dashboardVR"></div>

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.completed_jobs }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.jobs.completed') }}</span>
              </p>
            </div>
            <div class="dashboardVR"></div>

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.failed_jobs }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.jobs.failed') }}</span>
              </p>
            </div>
            <div class="dashboardVR"></div>

            <div class="displayColumn">
              <p class="mainNumber">
                {{ dashboardSummary.pending_jobs }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.jobs.pending') }}</span>
              </p>
            </div>
            <p class="mainNumber">
              <img src="/jobs.png" class="dashboardIcons" alt="" />
            </p>
          </div>
        </div>

        <div v-if="readPermission" class="col-lg-2">
          <div class="dashboardCard">
            <div class="displayColumn">
              <p class="mainNumber" style="text-align: center">
                {{ dashboardSummary.pending_manual_validation }}<br />
                <span class="summarySubTitleDashboard">{{ $t('dashboard.validation.pending') }}</span>
              </p>
            </div>
            <p class="mainNumber">
              <img src="/manual-validation.png" class="dashboardIcons" alt="" />
            </p>
          </div>
        </div>
      </div>

      <!-- Second Row: 2 columns -->

      <div v-if="readPermission" class="row mb-4" style="display: flex; align-items: center">
        <div class="col-lg-6" v-if="roleId === 2 || roleId === 1">
          <div class="dashboardCard" :style="{ height: roleId === 1 ? '140px' : '100%' }">
            <p class="mainNumber">
              <span class="mainTitleDashboard">{{ $t('dashboard.users.title') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.user_total }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.users.total') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.user_active }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.users.active') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.user_inactive }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.users.inactive') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.user_invited }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.users.invited') }}</span>
            </p>
            <p class="mainNumber">
              <img src="/users.png" class="dashboardIcons" alt="" />
            </p>
          </div>
        </div>

        <!-- Page Quota Utilization Section for Tenant Admin (roleId === 1) -->
        <div v-if="showQuotaSection && roleId === 1" class="col-lg-6">
          <div class="quota-section" style="height: 140px; position: relative">
            <div class="quota-header" style="display: flex; justify-content: space-between; align-items: center">
              <h3 class="quota-title">{{ $t('dashboard.page_quota.title') }}</h3>
              <div style="display: flex; align-items: center; gap: 16px">
                <div v-if="tenantQuotaInfo && tenantQuotaInfo.subscription_expiry_date" style="font-size: 12px; color: #666; text-align: right">
                  <span class="expiry-text">
                    {{ $t('dashboard.page_quota.expiring_on') }}
                    <strong style="color: #333">{{ tenantQuotaInfo.subscription_expiry_date }}</strong>
                  </span>
                </div>
              </div>
            </div>

            <div class="quota-content">
              <div class="quota-usage" style="display: flex; align-items: center; gap: 16px">
                <div class="usage-numbers" style="display: flex; flex-direction: column; align-items: flex-start">
                  <div style="font-size: 24px; font-weight: bold; line-height: 1">
                    <span class="pages-used">{{ dashboardSummary.lifetime_pages_processed }}</span>
                    <span class="separator">/</span>
                    <span class="pages-total">{{ tenantQuotaInfo?.total_pages_allocated }}</span>
                  </div>
                  <span class="usage-label" style="font-size: 12px; color: #666; margin-top: 4px">
                    <b>{{ $t('dashboard.page_quota.pages_utilized') }}</b></span
                  >
                </div>

                <div class="quota-bar-container" style="width: 100%">
                  <div class="quota-bar">
                    <div
                      class="quota-progress"
                      :style="{ width: quotaUtilizationPercentage + '%' }"
                      :class="{
                        'quota-warning': quotaUtilizationPercentage >= 85,
                        'quota-critical': quotaUtilizationPercentage >= 100,
                      }"
                    ></div>
                  </div>
                  <span class="quota-percentage">{{ quotaUtilizationPercentage }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6" v-if="roleId === 2">
          <div class="dashboardCard">
            <p class="mainNumber">
              <span class="mainTitleDashboard">{{ $t('dashboard.tenants.title') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.total_tenants }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.tenants.total') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.active_tenants }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.tenants.active') }}</span>
            </p>
            <div class="dashboardVR"></div>
            <p class="mainNumber">
              {{ dashboardSummary.inactive_tenants }}<br />
              <span class="summarySubTitleDashboard">{{ $t('dashboard.tenants.inactive') }}</span>
            </p>
            <p class="mainNumber">
              <img src="/tenants.png" class="dashboardIcons" alt="" />
            </p>
          </div>
        </div>
      </div>
      <!-- Overlay loader -->
      <div v-if="loadingStates.dashboardSummary" class="summary-loader-overlay">
        <div class="spinner"></div>
      </div>
    </div>

    <!-- Page Quota Utilization Section -->
    <div v-if="showQuotaSection && roleId === 2" class="row mb-4">
      <div class="col-lg-12">
        <div class="quota-section">
          <div class="quota-header">
            <h3 class="quota-title">{{ $t('dashboard.page_quota.title') }}</h3>
            <div v-if="loadingStates.tenantQuota" class="spinner"></div>
          </div>

          <div class="quota-content">
            <div class="quota-usage">
              <div class="usage-numbers">
                <span class="pages-used">{{ dashboardSummary.lifetime_pages_processed }}</span>
                <span class="separator">/</span>
                <span class="pages-total">{{ tenantQuotaInfo?.total_pages_allocated }}</span>
                <span class="usage-label">{{ $t('dashboard.page_quota.pages_utilized') }}</span>
              </div>

              <div class="quota-bar-container">
                <div class="quota-bar">
                  <div
                    class="quota-progress"
                    :style="{ width: quotaUtilizationPercentage + '%' }"
                    :class="{
                      'quota-warning': quotaUtilizationPercentage >= 85,
                      'quota-critical': quotaUtilizationPercentage >= 100,
                    }"
                  ></div>
                </div>
                <span class="quota-percentage">{{ quotaUtilizationPercentage }}%</span>
              </div>

              <div v-if="tenantQuotaInfo && tenantQuotaInfo.subscription_expiry_date" class="expiry-info">
                <span class="expiry-text">
                  {{ $t('dashboard.page_quota.expiring_on') }}
                  <strong>{{ tenantQuotaInfo.subscription_expiry_date }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Third Row: Full width recent jobs table -->
    <div v-if="readPermission" class="row">
      <div class="col-lg-12" v-if="showJobHistory">
        <JobGrid :role-id="roleId" :show-job-history="showJobHistory" />
      </div>
    </div>
    <div v-if="!readPermission">
      <PermissionAlert :message="$t('dashboard.no_permission')" />
    </div>

    <!-- Date Range Modal -->

    <div v-if="showFilter" class="filter-modal-overlay" @click.self="closeFilterModal">
      <div class="filter-modal">
        <div class="filter-modal-header">
          <h2 class="apply-filters-title">{{ $t('dashboard.apply_filter') }}</h2>
          <button class="close-button" @click="closeFilterModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
              <path d="M5.48633 4.66602L16.2882 16.3319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.48527 16.3319L16.2871 4.66602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="filter-content">
          <div class="filter-section">
            <label class="filter-label">{{ $t('dashboard.upload_date_range') }}</label>
            <div class="date-input-container">
              <Datepicker v-model="dateRange" range :format="dateFormat" placeholder="MM/DD/YY - MM/DD/YY" :enable-time-picker="false" :clearable="true" class="date-picker" :range-separator="' - '" :multi-calendars="true" :auto-apply="true" text-input :calendar-icon="false" />
            </div>
          </div>
          <div class="filter-actions">
            <button class="cancel-button" @click="closeFilterModal">{{ $t('common.cancel') }}</button>
            <button class="apply-button" @click="applyFilter">{{ $t('dashboard.apply_filter') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import Header from '../../components/Header.vue'
import PermissionAlert from '../../components/PermissionAlert.vue'
import { get } from '@/utils/api'
import { showToast } from '@/utils/toast'
import JobGrid from './JobGrid.vue'
import CustomDropdown from '@/components/CustomDropdown/CustomDropdown.vue'
import Datepicker from '@vuepic/vue-datepicker'
import tenantSelectionStore from '@/stores/tenantSelectionStore'

export default {
  components: {
    Header,
    PermissionAlert,
    JobGrid,
    Datepicker,
    CustomDropdown,
  },
  data() {
    return {
      dashboardSummary: {
        total_files_uploaded: 0,
        total_documents_processed: 0,
        total_jobs: 0,
        completed_jobs: 0,
        failed_jobs: 0,
        pending_jobs: 0,
        pending_manual_validation: 0,
        recent_jobs: [],
        total_pages_processed: 0,
      },
      tenantQuotaInfo: {
        total_pages_allocated: 0,
        subscription_expiry_date: '',
      },
      loadingStates: {
        dashboardSummary: false,
        tenants: false,
        tenantQuota: false,
      },
      roleId: null,
      showJobHistory: false,
      selectedFilter: 'Day',
      filterOptions: ['Day', 'Week', 'Month', 'Year'],
      fromDate: null,
      toDate: null,
      showFilter: false,
      dateRange: [],
      dateFormat: 'MM/dd/yyyy',
      tenants: [],
      selectedTenantId: '',
      selectedTenantUsesBedrock: false,
      selectedTenantUsesTextract: false,
      tenantStoreUnsubscribe: null,
    }
  },
  computed: {
    auth() {
      return useAuthStore()
    },
    filterLabels() {
      return this.filterOptions.map((opt) => this.$t(`dashboard.filter.${opt.toLowerCase()}`) || opt)
    },
    quotaUtilizationPercentage() {
      if (!this.tenantQuotaInfo || !this.tenantQuotaInfo.total_pages_allocated) return 0
      const pagesUsed = this.dashboardSummary.lifetime_pages_processed || 0
      return Math.round((pagesUsed / this.tenantQuotaInfo.total_pages_allocated) * 100)
    },
    showQuotaSection() {
      // Show only for Super Admin (role 2) and Tenant Admin (role 1) when specific tenant is selected
      return (this.roleId === 1 || this.roleId === 2) && this.selectedTenantId && this.selectedTenantId !== 'All' && this.readPermission
    },
  },
  created() {
    const userDataString = localStorage.getItem('UserData')
    if (userDataString) {
      const userData = JSON.parse(userDataString)
      if (!userData.first_name) {
        this.$router.push(`/update-user`)
        return
      }

      // Set selectedTenantId for Tenant Admin and Tenant User from userData
      const userRolesStr = localStorage.getItem('UserRoles')
      if (userRolesStr) {
        try {
          const userRoles = JSON.parse(userRolesStr)
          if (userRoles.length) {
            const roleId = userRoles[0].roleId
            // For Tenant Admin (1) and Tenant User (3), set selectedTenantId from userData
            if ((roleId === 1 || roleId === 3) && userData.tenant_id) {
              this.selectedTenantId = userData.tenant_id
            }
          }
        } catch (err) {}
      }
    }

    // Subscribe to tenant selection store for AI method updates
    this.tenantStoreUnsubscribe = tenantSelectionStore.subscribe((state) => {
      this.selectedTenantUsesBedrock = state.selectedTenantUsesBedrock
      this.selectedTenantUsesTextract = state.selectedTenantUsesTextract
    })

    // Get initial state from store
    const storeState = tenantSelectionStore.getState()
    this.selectedTenantUsesBedrock = storeState.selectedTenantUsesBedrock
    this.selectedTenantUsesTextract = storeState.selectedTenantUsesTextract

    this.setDateRangeByFilter(this.selectedFilter)
    this.checkPermissions()
    this.fetchDashboardSummary()
    this.fetchTenants()
  },
  mounted() {
    document.title = 'Dashboard'
    const userRolesStr = localStorage.getItem('UserRoles')
    if (userRolesStr) {
      try {
        const userRoles = JSON.parse(userRolesStr)
        if (userRoles.length) {
          // Pick the first roleId (assuming single-role assignment per user)
          this.roleId = userRoles[0].roleId
          if (userRoles[0].roleId !== 2) {
            this.showJobHistory = true
          }
        }
      } catch (err) {}
    }
  },
  beforeUnmount() {
    // Unsubscribe from tenant selection store
    if (this.tenantStoreUnsubscribe) {
      this.tenantStoreUnsubscribe()
    }
  },
  watch: {
    selectedTenantId() {
      this.fetchDashboardSummary()
      this.fetchTenantQuota()
    },
  },
  methods: {
    async fetchTenants() {
      try {
        this.loadingStates.tenants = true
        const response = await get('/v1/tenants?page=1&pageSize=100000')
        if (response && response.data) {
          this.tenants = [
            { value: 'All', label: 'Select Tenant' },
            ...response.data.data.tenants.map((t) => ({
              value: t.id,
              label: t.tenant_name,
              is_active: t.is_active,
            })),
          ]
        }
      } catch (error) {
        showToast({ title: 'Error', message: 'Failed to fetch tenants.', type: 'error' })
      } finally {
        this.loadingStates.tenants = false
      }
    },
    async fetchTenantQuota() {
      if (!this.selectedTenantId || this.selectedTenantId === 'All') {
        this.tenantQuotaInfo = {
          total_pages_allocated: 0,
          subscription_expiry_date: '',
        }
        return
      }

      this.loadingStates.tenantQuota = true
      try {
        const configResponse = await get(`/v1/tenant-configs/tenant/${this.selectedTenantId}`)

        if (configResponse?.data?.data) {
          const configData = configResponse.data.data
          const config = {}

          configData.forEach(({ key, value }) => {
            config[key] = value
          })

          this.tenantQuotaInfo.total_pages_allocated = parseInt(config.no_of_pages_licensed) || 0

          if (config.subscription_start_date) {
            const startDate = new Date(config.subscription_start_date)
            const expiryDate = new Date(startDate)
            expiryDate.setFullYear(startDate.getFullYear() + 1)
            this.tenantQuotaInfo.subscription_expiry_date = expiryDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
          }
        }
      } catch (error) {
      } finally {
        this.loadingStates.tenantQuota = false
      }
    },
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = permissions.some((p) => p.object_name === 'DASHBOARD_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'DASHBOARD_WR' && p.is_active)
    },

    showFilterModal() {
      this.showFilter = true
    },

    closeFilterModal() {
      this.showFilter = false
    },
    // formatNumber(num) {
    //   if (!num) return '0'
    //   if (num >= 1000000) {
    //     return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
    //   }
    //   if (num >= 1000) {
    //     return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
    //   }
    //   return num.toString()
    // },
    setDateRangeByFilter(option) {
      const now = new Date()
      let from = new Date(now) // ensure from is a new instance of now

      switch (option) {
        case 'Day':
          // from.setDate(now.getDate() - 1)
          from.setDate(now.getDate())
          break
        case 'Week':
          from.setDate(now.getDate() - 7)
          break
        case 'Month':
          from.setMonth(now.getMonth() - 1)
          break
        case 'Year':
          from.setFullYear(now.getFullYear() - 1)
          break
        default:
          from = null
      }

      // Update both dateRange and individual from/to fields
      if (from) {
        this.dateRange = [from, now]
        this.fromDate = from.toISOString().split('T')[0]
        this.toDate = now.toISOString().split('T')[0]
      } else {
        this.dateRange = null
        this.fromDate = null
        this.toDate = null
      }
    },

    selectFilter(option) {
      this.selectedFilter = option
      this.dateRange = null
      this.setDateRangeByFilter(option)
      this.fetchDashboardSummary()
    },

    clearDateFilter() {
      this.dateRange = null
      this.fromDate = null
      this.toDate = null
      this.selectedFilter = ''
      this.fetchDashboardSummary()
    },

    applyFilter() {
      if (this.dateRange && this.dateRange.length === 2) {
        const [start, end] = this.dateRange
        this.fromDate = new Date(start).toISOString().split('T')[0]
        this.toDate = new Date(end).toISOString().split('T')[0]
        this.selectedFilter = ''
        this.fetchDashboardSummary()
      }
      this.closeFilterModal()
    },

    formatDateForDisplay(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
    },

    async fetchDashboardSummary() {
      this.loadingStates.dashboardSummary = true
      try {
        const params = {}
        if (this.fromDate) params.fromDate = this.fromDate
        if (this.toDate) params.toDate = this.toDate
        if (this.selectedTenantId && this.selectedTenantId !== 'All') params.tenantId = this.selectedTenantId
        const res = await get(`/v1/dashboard/job-summary-report`, params)

        if (res.data && res.data.data) {
          this.dashboardSummary = res.data.data
        } else {
          this.dashboardSummary = {}
        }
      } catch (err) {
        showToast({ title: 'Error', message: 'Failed to fetch dashboard data', type: 'error' })
      } finally {
        this.loadingStates.dashboardSummary = false
      }
    },
  },
}
</script>

<style scoped>
@import '@/styles/jobHistory.css';

/* Base arrow icon style */
.arrowDownIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

/* Apply rotation when isOpen is false */
.arrowDownIcon.rotated {
  transform: rotate(-180deg);
}

.rotated {
  transform: rotate(-180deg);
}

.mainNumber {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.34px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.dashboardVR {
  width: 1px;
  height: 40px;
  /* was 64px */
  background: #ececec;
}

.mainTitleDashboard {
  color: #667085;
  font-family: Archivo;
  font-style: normal;
  font-weight: 400;
  line-height: 128%;
  /* 20.48px */
  letter-spacing: -0.16px;
  font-size: 14px;
  /* reduced from 16px */
  margin-top: 12px;
  /* tighter layout */
}

.summarySubTitleDashboard {
  color: #667085;
  font-family: Archivo;
  font-style: normal;
  font-weight: 400;
  line-height: 128%;
  /* 20.48px */
  letter-spacing: -0.16px;
  font-size: 14px;
  /* reduced from 16px */
  margin-top: -12px;
  /* tighter layout */
}

.mainTitleDashboardSingle {
  color: #667085;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 128%;
  /* 20.48px */
  letter-spacing: -0.16px;
}

.dashboardIcons {
  width: 48px;
  /* was 72px */
  height: 48px;
}

.displayColumn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
}

.dashboardCard {
  display: flex;
  padding: 14px 6px 6px 14px;
  /* reduced padding */
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid rgba(45, 54, 75, 0.1);
  background: #fff;
  box-shadow: 0px -1px 4px 0px rgba(15, 54, 65, 0.02);
}

h1 {
  color: #333;
}

.alert {
  margin-top: 20px;
  color: white;
  background-color: #dc3545;
  padding: 10px;
  border-radius: 5px;
}

.dayFilterButton {
  padding: 6px 16px;
  border-radius: 4px;
  background-color: white;
  color: #344054;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  height: 36px;
  width: 85px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background-color: #ffffff;
  opacity: 0.9;
}

.dayFilterButton:hover {
  background-color: #f6f8fa;
}

.dayFilterButton.selected {
  background-color: var(--secondary-color);
  color: #344054;
  border-color: var(--primary-color);
  /* box-shadow: 0 0 0 2px rgba(33, 136, 255, 0.2); */
  opacity: 1;
}

.summary-wrapper {
  position: relative;
}

.summary-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  /* transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 0.8s linear infinite;
}

.filter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.filter-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
}

.filter-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-modal-header h2 {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.24px;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  /* 100% */
  letter-spacing: 0.18px;
}

.filter-content {
  margin-top: 24px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-section label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.18px;
  margin-bottom: 12px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

.date-input-container input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container svg {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-button,
.apply-button {
  padding: 12px 24px;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button {
  background: white;
  border: 1px solid #e8e8e8;
  color: #5c656c;
}

.apply-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.filter-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.filter-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.filter-section select {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  color: #32393e;
  background: white;
  cursor: pointer;
}

.date-picker {
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

.date-filter-chip {
  display: inline-flex;
  align-items: center;
  background-color: #f5f6f7;
  border-radius: 6px;
  padding: 6px 12px;
  margin-left: 12px;
  gap: 8px;
}

.date-filter-text {
  color: #5c656c;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.date-filter-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.date-filter-clear:hover {
  background-color: #e8e9ea;
}

.date-filter-clear svg {
  width: 16px;
  height: 16px;
}

.quota-section {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.quota-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.quota-title {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.quota-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.usage-numbers {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.pages-used {
  font-size: 32px;
  font-weight: 700;
  color: var(--primary-color);
  font-family: Archivo;
}

.separator {
  font-size: 28px;
  color: #666;
  font-weight: 400;
}

.pages-total {
  font-size: 28px;
  font-weight: 500;
  color: #666;
  font-family: Archivo;
}

.usage-label {
  font-size: 16px;
  color: #666;
  margin-left: 8px;
  font-family: Archivo;
}

.quota-bar-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quota-bar {
  flex: 1;
  height: 12px;
  background-color: #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}

.quota-progress {
  height: 100%;
  background-color: var(--primary-color);
  transition: all 0.3s ease;
  border-radius: 6px;
}

.quota-progress.quota-warning {
  background-color: #ffc107;
}

.quota-progress.quota-critical {
  background-color: #dc3545;
}

.quota-percentage {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
  min-width: 40px;
  text-align: right;
  font-family: Archivo;
}

.expiry-info {
  margin-top: 8px;
}

.expiry-text {
  font-size: 14px;
  color: #666;
  font-family: Archivo;
}

.expiry-text strong {
  color: var(--primary-color);
  font-weight: 600;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
